export type SpotterLayerIconState = 'default' | 'selected' | 'highlight' | 'inactive';

type SpotterLayerIconStateMap = {
    default: string;
    selected: string;
    highlight?: string;
    inactive?: string;
};

type SpotterLayerIconNameSets = {
    spotter: SpotterLayerIconStateMap;
    scout: SpotterLayerIconStateMap;
};

export const MY_SPOTTER_LAYER_ICON_NAMES: SpotterLayerIconNameSets = {
    spotter: {
        default: 'spotter',
        selected: 'selected',
        highlight: 'highlight',
        inactive: 'inactive',
    },
    scout: {
        default: 'scout',
        selected: 'scout-selected',
        highlight: 'scout-highlight',
        inactive: 'scout-inactive',
    },
};

export const getSpotterLayerIconName = (state: SpotterLayerIconState, isScout: boolean): string => {
    const stateMap = isScout ? MY_SPOTTER_LAYER_ICON_NAMES.scout : MY_SPOTTER_LAYER_ICON_NAMES.spotter;
    return stateMap[state] ?? stateMap.default;
};
